/**
 * DIEUKYDIEU.TV - AUDIO PLAYER TABS, QUEUE LIST & PLAYBACK SPEED
 */

import { t } from '../i18n.js';
import { showToast } from '../ui.js';
import { audioPlaylist } from '../data/player-playlist.js';
import {
    currentAudioIndex,
    activePlayerTab,
    currentPlaybackSpeed,
    setActivePlayerTab,
    setCurrentPlaybackSpeed,
    setIsShuffle
} from './player-state.js';
import { getTrackTitle, getTrackArtist } from './player-dom.js';
import { updateLyricsHighlight } from './player-lyrics.js';
import { playAudio, playNext } from '../player.js';

export function switchPlayerTab(tabName) {
    setActivePlayerTab(tabName);

    const tabQueue = document.getElementById('btab-queue');
    const tabLyrics = document.getElementById('btab-lyrics');
    const paneNow = document.getElementById('fp-pane-now-playing');
    const paneQueue = document.getElementById('fp-pane-queue');
    const paneLyrics = document.getElementById('fp-pane-lyrics');
    const fullPlayer = document.getElementById('full-player');

    if (tabQueue) tabQueue.classList.toggle('active', tabName === 'queue');
    if (tabLyrics) tabLyrics.classList.toggle('active', tabName === 'lyrics');

    if (paneNow) paneNow.classList.toggle('active', tabName === 'now-playing');
    if (paneQueue) paneQueue.classList.toggle('active', tabName === 'queue');
    if (paneLyrics) paneLyrics.classList.toggle('active', tabName === 'lyrics');

    if (fullPlayer) {
        fullPlayer.classList.toggle('lyrics-expanded', tabName === 'lyrics');
    }

    if (tabName === 'lyrics') {
        const audioEl = document.getElementById('main-audio');
        if (audioEl) updateLyricsHighlight(audioEl.currentTime, true);
    }
}

export function toggleLyricsTab() {
    if (activePlayerTab === 'lyrics') {
        switchPlayerTab('now-playing');
    } else {
        switchPlayerTab('lyrics');
    }
}

export function toggleQueueTab() {
    if (activePlayerTab === 'queue') {
        switchPlayerTab('now-playing');
    } else {
        switchPlayerTab('queue');
    }
}

export function renderQueueList() {
    const list = document.getElementById('fp-queue-list');
    const countEl = document.getElementById('fp-queue-count');
    if (countEl) countEl.innerText = audioPlaylist.length.toString();
    if (!list) return;

    list.innerHTML = audioPlaylist.map((track, idx) => {
        const isCurrent = idx === currentAudioIndex;
        return `
            <div class="fp-queue-item ${isCurrent ? 'active' : ''}" onclick="playAudio(${idx})">
                <div class="fp-q-thumb" style="background-image: url('${track.img}')">
                    ${isCurrent ? `
                        <div class="fp-q-playing-overlay">
                            <span class="material-symbols-rounded">graphic_eq</span>
                        </div>
                    ` : ''}
                </div>
                <div class="fp-q-info">
                    <div class="fp-q-title">${getTrackTitle(track)}</div>
                    <div class="fp-q-artist">${getTrackArtist(track)}</div>
                </div>
                <div class="fp-q-duration">${track.duration || ''}</div>
            </div>
        `;
    }).join('');
}

export function shufflePlaylist() {
    setIsShuffle(true);
    const btn = document.getElementById('fp-shuffle-btn');
    if (btn) btn.classList.add('active');
    playNext();
    showToast(t('toast_shuffle_play'));
}

export function cyclePlaybackSpeed() {
    const audioEl = document.getElementById('main-audio');
    const speeds = [1.0, 1.25, 1.5, 0.75];
    const curIdx = speeds.indexOf(currentPlaybackSpeed);
    const nextIdx = (curIdx + 1) % speeds.length;
    setCurrentPlaybackSpeed(speeds[nextIdx]);

    if (audioEl) audioEl.playbackRate = currentPlaybackSpeed;
    const speedVal = document.getElementById('fp-speed-val');
    if (speedVal) {
        speedVal.innerText = `${currentPlaybackSpeed}x`;
    }
    const optSub = document.getElementById('fp-opt-speed-sub');
    if (optSub) {
        optSub.innerText = `${currentPlaybackSpeed}x ${currentPlaybackSpeed === 1.0 ? '(Bình thường)' : ''}`;
    }
    showToast(`Tốc độ phát: ${currentPlaybackSpeed}x`);
}
